(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-stacks"] && !Shopify.designMode) return;
  try {
    
// Goal nav. Hides cards, never reorders or fetches. If this script never runs,
// every stack stays visible - the filter is an enhancement, not a requirement.
(function () {
  document.querySelectorAll('[data-stacks-nav]').forEach(function (nav) {
    var section = nav.closest('.fx-stacks');
    var items = section ? section.querySelectorAll('.fx-stacks__grid > li') : [];
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.fx-stacks__pill');
      if (!btn) return;
      var goal = btn.getAttribute('data-goal') || '';
      nav.querySelectorAll('.fx-stacks__pill').forEach(function (p) {
        var on = p === btn;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      items.forEach(function (li) {
        li.hidden = goal !== '' && li.getAttribute('data-goal') !== goal;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
